export default "/assets/images/mila-feed-06.6cb13f301d9fbe23.mp4";